import type { ZealApiErrorResponse } from "@zeal/common";
import type { IGenEmployeeOnboardingLinkRequestBody } from "./IGenEmployeeOnboardingLinkRequestBody.jsonschema";
import type { IGenEmployeeOnboardingLinkResponseBody } from "./IGenEmployeeOnboardingLinkResponseBody.jsonschema";
import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { returnZealApiErrorResponse } from "../../returnZealApiErrorResponse";
import { IIDScanDocuments } from "../../../LaForgeClient/routes/getOnboardingAuthLink/getOnboardingAuthLink.jsonschema";

const PATH = "/employees/onboard";

type GenEmployeeOnboardingLinkResponse =
  | {
      readonly success: true;
      readonly data: IGenEmployeeOnboardingLinkResponseBody;
      readonly accountStageDisabled: boolean;
      readonly stageFlags: {
        readonly account: boolean;
        readonly i9: boolean;
        readonly idScan: boolean;
        readonly paymentMethod: boolean;
      };
      readonly idScanDocuments?: IIDScanDocuments;
    }
  | ZealApiErrorResponse;

export const genEmployeeOnboardingLink =
  (axios: IAxiosInstance) =>
  async (body: IGenEmployeeOnboardingLinkRequestBody) => {
    try {
      const response =
        await axios.noRetry.post<GenEmployeeOnboardingLinkResponse>(PATH, body);
      return response.data;
    } catch (err) {
      return returnZealApiErrorResponse(err);
    }
  };
